import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useCanonicalUrl, normalizeSiteBase, joinUrl, MARKETING_ROUTES } from './seoUtils';

type CanonicalProps = {
	override?: string;
};

const Canonical: React.FC<CanonicalProps> = ({ override }) => {
	const location = useLocation();

	// Only marketing pages get SEO directives
	const shouldRenderSEO = MARKETING_ROUTES.includes(location.pathname);

	if (!shouldRenderSEO) {
		return null;
	}

	// Get base URL using shared hook
	const { base } = useCanonicalUrl();

	const path = `${location.pathname}${location.search || ''}`;

	let canonical = '';
	if (override) {
		if (/^https?:\/\//i.test(override)) {
			canonical = normalizeSiteBase(override);
		} else {
			canonical = joinUrl(base, override.startsWith('/') ? override : `/${override}`);
		}
	} else {
		canonical = joinUrl(base, path);
		// remove trailing slash for non-root paths
		if (canonical.endsWith('/') && canonical !== `${base}/`) {
			canonical = canonical.replace(/\/$/, '');
		}
	}
	return (
		<>
			<Helmet>
				<link rel="canonical" href={canonical} data-react-managed="true" />
				<meta name='robots' content='index, follow' />
			</Helmet>
		</>
	);
};

export default Canonical;
